import { get_, post_ } from './base'
import type { Coupon } from '@/types/coupon'

export type CouponListResponse = {
  total: number
  results: Coupon[]
}

export type GetCouponListParams = {
  pageSize?: number
  page?: number
  userId?: string
  from?: number
  to?: number
  status?: string
  couponId?: string
  [key: string]: any
}

export type CreateCouponParams = {
  name: string
  faceValue: number
  validFrom?: number
  validUntil?: number
  comment?: string
  type: string
  allProduct?: boolean
  productTypes?: string[]
  regions?: string[]
  clusterIds?: string[]
  planIds?: string[]
  purchaseMethods?: string[]
  orderTypes?: string[]
}

const getParamsStr = (params: GetCouponListParams) => {
  return Object.keys(params || {})
    .filter(
      key => params[key] !== undefined && params[key] !== null && params[key],
    )
    .map(key => `${key}=${params[key]}`)
    .join('&')
}

const billApiPrefix = '/api/sa/bill'
// 管理员获取优惠券列表
export const getCouponListByAdmin = async (
  params: GetCouponListParams,
): Promise<CouponListResponse> => {
  const paramsStr = getParamsStr(params)
  return get_(`${billApiPrefix}/api/v1/admin/coupon/coupons?${paramsStr}`)
}
// 创建优惠券
export const createCoupon = async (
  params: CreateCouponParams,
): Promise<Coupon> => {
  return post_(`${billApiPrefix}/api/v1/admin/coupon/coupons`, params)
}
// 手动发放优惠券
export const sendCouponManually = async (
  couponId: string,
  data: any,
): Promise<void> => {
  return post_(
    `${billApiPrefix}/api/v1/admin/coupon/coupons/${couponId}/issue`,
    data,
  )
}
// 作废优惠券
export const invalidateCoupon = async (couponId: string): Promise<void> => {
  return post_(
    `${billApiPrefix}/api/v1/admin/coupon/coupons/${couponId}/void`,
    {},
  )
}
// 获取代金券详情
export const getCouponDetail = async (couponId: string): Promise<Coupon> => {
  return get_(`${billApiPrefix}/api/v1/admin/coupon/coupons/${couponId}`)
}
// 获取指定ID的代金券详情
export const getUserCouponDetailById = async (id: string): Promise<Coupon> => {
  return get_(`${billApiPrefix}/api/v1/admin/coupon/user-coupons/${id}`)
}
// 用户获取代金券列表
export const getCouponListByUser = async (
  params: GetCouponListParams,
): Promise<CouponListResponse> => {
  const paramsStr = getParamsStr(params)
  return get_(`${billApiPrefix}/api/v1/coupons/list?${paramsStr}`)
}
// 获取用户代金券详情
export const getCouponDetailByUser = async (
  couponId: string,
): Promise<Coupon> => {
  return get_(`${billApiPrefix}/api/v1/coupons/${couponId}`)
}
// 管理员作废用户的某张优惠券
export const invalidateUserCoupon = async (couponId: string): Promise<void> => {
  return post_(
    `${billApiPrefix}/api/v1/admin/coupon/user-coupons/${couponId}/void`,
    {},
  )
}
// 管理员获取某张优惠券的发放用户
export const getIssuedUsers = async (
  params: GetCouponListParams,
): Promise<void> => {
  const paramsStr = getParamsStr(params)
  return get_(`${billApiPrefix}/api/v1/admin/coupon/user-coupons?${paramsStr}`)
}
// 获取优惠券的适用产品列表
export const getCouponProducts = async (
  params: GetCouponListParams,
): Promise<void> => {
  const paramsStr = getParamsStr(params)
  return get_(
    `${billApiPrefix}/api/v1/admin/coupon/coupons/${params.couponId}/plans?${paramsStr}`,
  )
}
// 获取优惠券的使用历史
export const getCouponUsageHistory = async (
  couponId: string,
  params: GetCouponListParams,
): Promise<void> => {
  const paramsStr = getParamsStr(params)
  return get_(
    `${billApiPrefix}/api/v1/coupons/${couponId}/usage-records?${paramsStr}`,
  )
}

// 获取用户优惠券数量统计
export const getUserCouponStats = async (): Promise<{
  activeCount: number
  allCount: number
}> => {
  return get_(`${billApiPrefix}/api/v1/coupons/stats`)
}
